import { Component, OnInit, AfterContentInit } from '@angular/core';
import { AppRoutingService } from './modules/app-routing.service';
import { Router, RouterEvent } from '@angular/router';
import { CognitoService } from './services/cognito/cognito.service';
import { Location } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'app';

  public showLogout: boolean;

  constructor(private routingService: AppRoutingService,
    public cognitoService: CognitoService,
    private router: Router, public location: Location) {

   router.events.filter(e => e instanceof RouterEvent).subscribe((val: RouterEvent) => {
      if (val.url == "/id_token") {
        var hash = window.location.hash.substr(1);

        var hashMap = hash.split('&').reduce(function (res, item) {
          var parts = item.split('=');
          res[parts[0]] = parts[1];
          return res;
        }, {});
        this.cognitoService.authenticateWithIdToken(hashMap['id_token']);
      // this.router.navigate([]);
      }
      this.showLogout = this.cognitoService.isAuthenticated();
    });

  }


  ngOnInit() {
    this.routingService.loadRouting();
    if (this.cognitoService.isAuthenticated()) {
       this.router.navigate(['/transactions']);
    }
  }

  onActivate(event) {
    window.scroll(0, 0);
    if (!this.cognitoService.isAuthenticated() && !this.cognitoService.isFinalizingLogin()) {
      this.cognitoService.authAzure();
    }
  }
  
  logout() {
    this.cognitoService.logout();
    this.router.navigate(['/']);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts